module.exports = __webpack_public_path__ + "fonts/VaIcons.f5528afe.woff";